import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout, Field } from "@/components/AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", f);
      login(data.token, data.user);
      toast.success("Xoş gəldiniz!");
      nav(data.user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Giriş" subtitle="Hesabınıza daxil olun və oynamağa başlayın">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="email@nümunə.az" data-testid="login-email-input" />
        <Field label="Parol" type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="••••••••" data-testid="login-password-input" />
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-sm text-[#D4AF37] hover:text-[#FFD700] transition-colors" data-testid="forgot-password-link">Parolu unutmusunuz?</Link>
        </div>
        <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="login-submit-btn">{loading ? "Gözləyin..." : "Daxil ol"}</button>
        <p className="text-center text-sm text-zinc-400">Hesabınız yoxdur? <Link to="/register" className="text-[#D4AF37]" data-testid="go-register-link">Qeydiyyat</Link></p>
      </form>
    </AuthLayout>
  );
}
